module.exports = __webpack_public_path__ + "static/illustration-2-f31df00e632f9b24f5f4a4077e34edb8.jpg";